module.exports = __webpack_public_path__ + "static/media/gf_show.ff62c563.jpg";